/** Global session-expired modal state (triggered from non-React API layer). */

let isOpen = false;
const listeners = new Set();

function emit() {
  listeners.forEach((listener) => listener());
}

export function subscribeSessionExpired(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSessionExpiredOpen() {
  return isOpen;
}

export function triggerSessionExpired() {
  if (isOpen) {
    return;
  }
  isOpen = true;
  emit();
}

export function resetSessionExpired() {
  isOpen = false;
  emit();
}
